import { SortDirection, SortEvent } from "@allianz/ng-aquila/table";
import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import * as moment from "moment";
import { AppConfig } from "src/config/app.config";
import { AuthService } from "../core/auth/auth.service";
import { CustomErrorHandler } from "../core/custom-error-handler";
import { PolicyStatus } from "../core/policyStatus.model";
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';

@Component({
  selector: "app-policysale-monthly-detailed-report",
  templateUrl: "./policysale-monthly-detailed-report.component.html",
  styleUrls: ["./policysale-monthly-detailed-report.component.css"],
  standalone: false
})
export class PolicysaleMonthlyDetailedReportComponent implements OnInit {
  @Input() month: moment.Moment;
  @Input() year: moment.Moment;

  reportSearchForm: FormGroup;

  fileName: string;
  ReportData: any;
  exportdata: any = [];
  _apiUrl: string;
  clientId: number;
  userTypeId: number;
  userBaseTypeId: number;
  userId: number;

  /** sorting starts here */

  sortTable(sort: SortEvent) {
    this.ReportData = this.ReportData.sort((a, b) => {
      if (sort.active in a && sort.active in b) {
        return this.compare(a[sort.active], b[sort.active], sort.direction);
      }
      return 0;
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection
  ) {
    return (a < b ? -1 : 1) * (direction === "asc" ? 1 : -1);
  }
  /** sorting ends here */
  /**Pagination Start */
  count: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;
  searchTerm: any = "";
  prevPage() {
    this.pageNumber--;
    this.getReportData();
  }

  nextPage() {
    this.pageNumber++;
    this.getReportData();
  }

  goToPage(n: number) {
    this.pageNumber = n;
    this.getReportData();
  }
  /**Pagination end */

  constructor(
    private authService: AuthService,
    private appConfig: AppConfig,
    private errorHandler: CustomErrorHandler
  ) {
    this._apiUrl = appConfig.baseUrl;
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.userBaseTypeId = parseInt(
      atob(localStorage.getItem("USER_BASE_TYPE_ID"))
    );
    this.userTypeId = parseInt(atob(localStorage.getItem("USER_TYPE_ID")));
  }
  ngOnInit(): void { }

  loadReport() {
    this.pageNumber = 1;
    this.getReportData();
  }

  getReportData() {
    this.authService
      .getList(
        this._apiUrl +
        `/api/v2/Report/MonthlyDetailedPolicySaleReport?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&udf1=${this.month}&udf2=${this.year}`
      )
      .subscribe(
        (response) => {
          if (response) {
            this.ReportData = response.body;
            var pagingProp = JSON.parse(response.headers.get("X-Pagination"));
            this.count = pagingProp.TotalCount;
          }
        },
        (error) => {
          this.errorHandler.handleError(error);
        }
      );
  }

  exporttoexcel() {
    this.pageNumber = -1;
    this.getExportData();
  }

  getExportData() {
    this.authService
      .getList(
        this._apiUrl +
        `/api/v2/Report/MonthlyDetailedPolicySaleReport?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&udf1=${this.month}&udf2=${this.year}`
      )
      .subscribe(
        (response) => {
          if (response) {
            this.exportdata = [];
            response.body.forEach((element) => this.setExportData(element));
            this.bindexcel();
          }
        },
        (error) => {

        }
      );
  }

  setExportData(item: any) {
    const data: any = {
      srNo: item.srNo,
      rsm: item.rsm,
      asm: item.asm,
      dealerCode: item.dealerCode,
      dealerName: item.dealerName,
      state: item.state,
      city: item.city,
    };

    let total = 0;

    for (let i = 1; i <= 31; i++) {
      const key = `d${i}`;
      const value = item[key] ?? 0;
      data[key] = value;
      total += Number(value);
    }

    data.total = item.total ?? total;
    this.exportdata.push(data);
  }

  bindexcel() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('PolicyDetailedMonthlySaleReport');

    // Define header row
    const headerRow = [
      'Sr.No', 'RSM', 'Area Manager', 'Dealer Code', 'Dealer Name', 'State', 'City',
      ...Array.from({ length: 31 }, (_, i) => `${i + 1}`),
      'Total'
    ];

    worksheet.addRow(headerRow);

    // Add export data
    this.exportdata.forEach(item => {
      const row = [
        item.srNo,
        item.rsm,
        item.asm,
        item.dealerCode,
        item.dealerName,
        item.state,
        item.city,
        ...Array.from({ length: 31 }, (_, i) => item[`d${i + 1}`] ?? 0),
        item.total
      ];
      worksheet.addRow(row);
    });

    // // Style header row
    // worksheet.getRow(1).eachCell(cell => {
    //   cell.font = { bold: true };
    //   cell.alignment = { vertical: 'middle', horizontal: 'center' };
    //   cell.fill = {
    //     type: 'pattern',
    //     pattern: 'solid',
    //     fgColor: { argb: 'FFDCE6F1' }
    //   };
    //   cell.border = {
    //     top: { style: 'thin' },
    //     left: { style: 'thin' },
    //     bottom: { style: 'thin' },
    //     right: { style: 'thin' }
    //   };
    // });

    // Auto width
    worksheet.columns.forEach(column => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, cell => {
        const value = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, value.length);
      });
      column.width = maxLength + 2;
    });

    // Save file
    this.fileName =
      "PolicyDetailedSaleMonthlyReport_" +
      new Date(Date.now()).toLocaleString().split(",")[0] +
      ".xlsx";
    this.saveAsExcelFile(workbook, this.fileName);
  }

  saveAsExcelFile(wb: any, fileName: string): void {
    wb.xlsx.writeBuffer().then((data) => {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var a = window.document.createElement('a');
      var downloadUrl = window.URL.createObjectURL(blob);
      a.href = downloadUrl;
      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    });
  }
}
